import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { getNewFileFormGroup } from '@app/helpers/form.helper';
import { FileUploadControl } from '@app/models/form.models';
import { FileType } from '@app/models/shared.enums';

export interface DocumentUploadFormGroup {
  authPartner: FormGroup<FileUploadControl>;
  authRepresentative: FormGroup<FileUploadControl>;
  signature: FormGroup<FileUploadControl>;
}

export function getDocumentUploadFormGroup(
  this: any,
  fb: FormBuilder,
): FormGroup<DocumentUploadFormGroup> {
  return fb.nonNullable.group({
    authPartner: getNewFileFormGroup(
      fb,
      FileType.userLegalEntityRightDocuPoAAuthorizedPartner,
      true,
    ),
    authRepresentative: getNewFileFormGroup(
      fb,
      FileType.userLegalEntityRightDocuPoAAuthorizedRepresentative,
      true,
    ),
    signature: getNewFileFormGroup(
      fb,
      FileType.userLegalEntityRightDocuAuthorizedRepresentativeSignatureSpecimen,
      true,
    ),
  });
}

export function getDefaultDocumentUploadFormArray(
  fb: FormBuilder,
  fileType: FileType,
): FormArray<FormGroup<FileUploadControl>> {
  return fb.array<FormGroup<FileUploadControl>>([
    getNewFileFormGroup(fb, fileType),
  ]);
}
